export default {
    desc: "รายละเอียด",
    sections: {
        meats: "เลือก",
        side: "อาหารทานเล่น",
        drinks: "เครื่องดื่ม",
        addOn: "เพิ่มเติม",
        ingredients: "ส่วนผสม",
        quantity: "จำนวน"
    },
    optional: "ตัวเลือก",
    btnAddToBag: "เพิ่มลงตระกร้า",
    priceLabel: "ราคา {0} บาท",
    price: "ราคา",
    priceUnit: "บาท",
    err_more_then_40: 'รายการสั่งซื้อไม่สามารถสั่งยอดได้เกิน 40 ชิ้นต่อรายการ กรุณาทำรายการสั่งซื้อใหม่'
}
